import React from 'react'
import DocumentCommentStats from './DocumentCommentStats';
import { Link } from 'react-router-dom';

function SearchTile(props) {

    console.log(props);
    const formatText = (text) => {
        if (!text) return "";

        // Replace **bold** text
        let formatted = text.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong><br/>");

        // Add indentation for lines starting with *
        formatted = formatted.replace(
            /(^|\n)\*(.*)/g,
            '$1<span style="margin-left: 2em; display: block;">$2</span>'
        );

        // Indent lines starting with numbers like 1., 2), 3:
        formatted = formatted.replace(
            /(^|\n)\d+[.):](.*)/g,
            '$1<span style="margin-left: 2em; display: block;">$&</span>'
        );

        // Replace newlines with <br/>
        //formatted = formatted.replace(/\n\n/g, "\n");
        formatted = formatted.replace(/\n/g, "<br/>");

        return formatted;
    };

    return (
        <div>
            <div className="document-tile">
                <div className="document-tile-metadata">
                    <h4><Link to={props.url}>{props.title}</Link></h4>
                    <p><b>Relevance Score:{props.score}</b></p>
                    <div dangerouslySetInnerHTML={{ __html: props.snippet }} />
                    <br />
                </div>
                <div className="document-tile-stats">
                    {/*<DocumentCommentStats documentId={props.documentId}></DocumentCommentStats>*/}
                </div>
            </div>
            <hr />
        </div>

    )
}

export default SearchTile;